export default __webpack_public_path__ + "static/media/airdrop.30bab92d.svg";